// Side-effect barrel for the legacy findProspects subtree (WEB-8484). root.jsx creates the
// ReactTemplates.findProspect namespace; the rest populate its keys at module eval. Loaded once
// by ReactTemplatesShim at the React entry (root first). Order mirrors the old legacy-react.js.
import './root';
import './sidebar';
import './companyBranchFilter';
import './companyInfoFilter';
import './companyLocationFilter';
import './startInfo';
import './rangeGraph';
import './rangeGraphFilter';
